import request from "@/utils/request";

// 反馈列表
export const getFeedbackList = (params) => {
  return request.post(`/sport-manage/feedback/user/getList`, params)
};

export const getTypeUser = (id) => {
  return request.get(`/sport-manage/feedback/user/getTypeList/${id}`)
}

// 反馈视频列表
export const getFeedbackVideo = (params) => {
  return request.post(`/sport-manage/task/getVideoList`, params)
};

// 获取训练类型字典接口  && 训练才有
export const getTrainType = () => {
  return request.get(`/sport-manage/task/getTrainType/training`)
};

// 获取运动类型字典接口
export const getSportType = (type) => {
  return request.get(`/sport-manage/task/getSportTypeList/${type}`)
};

// 下载视频接口(已废弃，接口采用数据流不是blob)
export const downloadVideo = (params) => {
  return request({
    responseType: "blob",
    url: `/pushup-admin/feedback/video/download`,
    method: "get",
    params,
  });
};

// 反馈详情
export const getFeedbackDetail = (id) => {
  return request.get(`/sport-manage/feedback/user/getDetail/${id}`)
}

// 更改反馈状态
export const changeFeedbackStatus = (params) => {
  return request.post(`/sport-manage/feedback/user/updStatus`, params)
}